import * as moment from "moment";
export const previousDay = new Date(new Date().setDate(new Date().getDate() - 1));
export const holdingDownloadDate = new Date(2022, 2, 31);
export const pnlDownloadDate = new Date(2013, 2, 31);
export const getDay = (to) => {
    return new Date().setDate(new Date().getDate() + to);
};
export const getDateInFormat = (date, format) => {
    return moment(date).format(format);
};
export const getTimeFormat = (milliseconds, hourFormat) => {
    if (!hourFormat) {
        hourFormat = 12;
    }
    const timeObj = {
        seconds: Math.floor((milliseconds / 1000) % 60).toString(),
        minutes: Math.floor((milliseconds / 1000 / 60) % 60).toString(),
        hours: Math.floor((milliseconds / 1000 / 60 / 60) % hourFormat).toString(),
    };
    return timeObj;
};
export const getFinancialYear = (date) => {
    if (date < new Date(date.getFullYear(), 3, 1)) {
        return date.getFullYear() - 1;
    }
    else
        return date.getFullYear();
};
export const getFinancialYears = (startDate, endDate, isTillDate = false) => {
    if (startDate && endDate) {
        const startYear = getFinancialYear(startDate);
        const endYear = getFinancialYear(endDate);
        const adjustedEndYear = isTillDate ? endYear : endYear + 1;
        return {
            start: startYear.toString().substring(2),
            end: endYear.toString().substring(2),
            label: `FY ${startYear}-${adjustedEndYear.toString().substring(2)}`,
        };
    }
};
export const getDefaultDateRanges = (numberOfDays, format) => {
    return {
        startDate: moment().subtract(numberOfDays, "days").format(format),
        endDate: moment().format(format),
    };
};
export const getFormattedDateTime = (date, time) => {
    let updatedDate = moment(date).format("DD-MMM-YY");
    return updatedDate + ", " + time;
};
export const convertNumOfMonthsToYears = (numOfMonths) => {
    return Math.floor(Number(numOfMonths) / 12);
};
export const ipoRemainigDays = (date, type) => {
    return moment(date).diff(moment().format("DD-MMM-YY"), "days") === 0
        ? "Closing Today"
        : `Day ${moment(date).diff(moment().format("DD-MMM-YY"), "days")} `;
};
export var IDiffTypes;
(function (IDiffTypes) {
    IDiffTypes["DAYS"] = "days";
    IDiffTypes["YEARS"] = "years";
})(IDiffTypes || (IDiffTypes = {}));
export const daysDifferenceFromCurrent = (date, type) => {
    return moment(date).diff(moment().format("DD-MMM-YY"), type ? type : "days");
};
export const getFinancialFirstDay = () => {
    if (new Date() >= new Date(new Date().getFullYear(), 3, 1)) {
        return new Date(new Date().getFullYear(), 3, 1);
    }
    else {
        return new Date(new Date().getFullYear() - 1, 3, 1);
    }
};
// Get the start date and end date of this month with following conditions
// 1) If today is 1st of the month give dates of previous month
// 2) Dates should not exceed yesterday's date
export const getThisMonthStartAndEndDate = () => {
    const today = moment();
    // If today is the 1st of the month, get dates of the previous month
    const startDate = today.clone().startOf("month");
    if (today.date() === 1) {
        startDate.subtract(1, "month");
    }
    // End of the current month, but not exceeding yesterday
    const endDate = moment.min(today.clone().endOf("month"), moment().subtract(1, "day"));
    return {
        startDate: startDate,
        endDate: endDate,
    };
};
export const isFirstDateOfQuarter = () => {
    const today = moment();
    const currentQuarterStart = moment().startOf("quarter");
    return today.isSame(currentQuarterStart, "day");
};
export const getPreviousIndianFinancialYear = () => {
    const today = moment();
    const currentYear = today.year();
    const financialYearStartMonth = 3; // April (0-indexed)
    let startDate, endDate;
    if (today.month() < financialYearStartMonth) {
        startDate = moment([currentYear - 2, financialYearStartMonth, 1]);
        endDate = moment([currentYear - 1, financialYearStartMonth, 1]).subtract(1, "day");
    }
    else {
        startDate = moment([currentYear - 1, financialYearStartMonth, 1]);
        endDate = moment([currentYear, financialYearStartMonth, 1]).subtract(1, "day");
    }
    return {
        startDate: startDate,
        endDate: endDate,
    };
};
export const isFirstDayOfFinancialYear = () => {
    const today = moment();
    const financialYearStart = moment([today.year(), 3, 1]); // April (0-indexed)
    return today.isSame(financialYearStart, "day");
};
//get the start date and end date of current indian financial year using moment js
//ensuring that the end date does not exceed today's date
export const getCurrentIndianFinancialYear = () => {
    const yesterday = moment().subtract(1, "day");
    const currentYear = yesterday.year();
    const financialYearStartMonth = 3; // April (0-indexed)
    let startDate, endDate;
    if (yesterday.month() < financialYearStartMonth) {
        startDate = moment([currentYear - 1, financialYearStartMonth, 1]);
        endDate = moment.min(moment([currentYear, financialYearStartMonth, 1]).subtract(1, "day"), yesterday);
    }
    else {
        startDate = moment([currentYear, financialYearStartMonth, 1]);
        endDate = moment.min(moment([currentYear + 1, financialYearStartMonth, 1]).subtract(1, "day"), yesterday);
    }
    return {
        startDate: startDate,
        endDate: endDate,
    };
};
export var ETimeRange;
(function (ETimeRange) {
    ETimeRange["THIS_MONTH"] = "This Month";
    ETimeRange["LAST_MONTH"] = "Last Month";
    ETimeRange["THIS_QUARTER"] = "This Quarter";
    ETimeRange["LAST_QUARTER"] = "Last Quarter";
    ETimeRange["YEARLY"] = "Yearly";
    ETimeRange["TILL_DATE"] = "Till Date";
    ETimeRange["CUSTOM_TIME_RANGE"] = "Custom Time Range";
})(ETimeRange || (ETimeRange = {}));
export var EDurationType;
(function (EDurationType) {
    EDurationType["CM"] = "CM";
    EDurationType["LM"] = "LM";
    EDurationType["CQ"] = "CQ";
    EDurationType["LQ"] = "LQ";
    EDurationType["CY"] = "CY";
    EDurationType["NA"] = "NA";
})(EDurationType || (EDurationType = {}));
export const addDays = (date, days) => {
    const newDate = new Date(date);
    newDate.setDate(newDate.getDate() + days);
    return newDate;
};
const adjustMonthAndYear = (month, year) => {
    if (month < 0) {
        return { adjustedMonth: (month + 12) % 12, adjustedYear: year - 1 };
    }
    return { adjustedMonth: month, adjustedYear: year };
};
const adjustQuarterAndYear = (quarter, year) => {
    if (quarter < 1) {
        return { adjustedQuarter: quarter + 4, adjustedYear: year - 1 };
    }
    return { adjustedQuarter: quarter, adjustedYear: year };
};
const getQuarterDateRange = (quarter, year) => {
    const startMonth = (quarter - 1) * 3;
    const endMonth = startMonth + 2;
    const startDate = new Date(year, startMonth, 1);
    const endDate = new Date(year, endMonth + 1, 0);
    return { startDate, endDate };
};
export const getThisMonthDateRange = () => {
    const now = new Date();
    const isFirstDayOfMonth = now.getDate() === 1;
    let thisMonth = isFirstDayOfMonth ? now.getMonth() - 1 : now.getMonth();
    let thisYear = now.getFullYear();
    const { adjustedMonth, adjustedYear } = adjustMonthAndYear(thisMonth, thisYear);
    const startDate = new Date(adjustedYear, adjustedMonth, 1);
    const endDate = previousDay;
    return { startDate, endDate, year: adjustedYear };
};
export const getLastMonthDateRange = () => {
    const now = new Date();
    const isFirstDayOfMonth = now.getDate() === 1;
    let lastMonth = isFirstDayOfMonth ? now.getMonth() - 2 : now.getMonth() - 1;
    let lastYear = now.getFullYear();
    const { adjustedMonth, adjustedYear } = adjustMonthAndYear(lastMonth, lastYear);
    const startDate = new Date(adjustedYear, adjustedMonth, 1);
    const endDate = new Date(adjustedYear, adjustedMonth + 1, 0);
    return { startDate, endDate, year: adjustedYear };
};
export const getCurrentQuarter = (date) => Math.ceil((date.getMonth() + 1) / 3);
export const selectQuarterDateRange = (prevQuarter = 0) => {
    const now = new Date();
    const currentQuarter = getCurrentQuarter(now);
    const isFirstDayOfQuarter = now.getDate() === 1 && [0, 3, 6, 9].includes(now.getMonth());
    let thisQuarter = isFirstDayOfQuarter
        ? currentQuarter - 1 - prevQuarter
        : currentQuarter - prevQuarter;
    let thisYear = now.getFullYear();
    const { adjustedQuarter, adjustedYear } = adjustQuarterAndYear(thisQuarter, thisYear);
    return getQuarterDateRange(adjustedQuarter, adjustedYear);
};
export const getFYdateRange = () => {
    return isFirstDayOfFinancialYear() ? getPreviousIndianFinancialYear() : getCurrentIndianFinancialYear();
};
export const checkMarchPeriod = () => {
    return moment().month() === 2;
};
export const startDateForTaxBudget = new Date(2024, 3, 1);
export const endDateForTaxBudget = new Date(2025, 2, 31);
export const tillDateStartDate = new Date(2013, 2, 31);
